import { Event } from '@/event-bus/event';

export class InvoiceBatchCreationFailedEvent extends Event<void> {}
